module.exports = __webpack_public_path__ + "static/yakfolk_warrior-a7a66e6692a638e21e7e3e1f5a10c5a2.png";